import noop from './noop';
/**
 * 图片懒加载
 * @param {图片地址，数组} images
 * @param {每次加载回调} callback
 *
 * loadImages(['https://....']).then(() => {})
 */
const loadImages = (images: string[], callback?: (v: number) => void) => {
  let haveLoadedCount = 0;
  return new Promise((resolve) => {
    const loadedOne = () => {
      haveLoadedCount += 1;
      callback && callback(haveLoadedCount);
      if (haveLoadedCount === images.length) {
        resolve(haveLoadedCount);
      }
    };

    const load = (src: string) => {
      const image = new Image();

      image.onload = loadedOne;
      image.onerror = loadedOne;
      image.src = src;
    };

    if (images && images.length) {
      images.map(load);
    } else {
      resolve(0);
    }
  });
};

export { loadImages };
